import { useOrganizationStatusCount } from "@/api/services/admin/organization";
import { useEnum } from "@/api/services/global/enum";
import { OrganizationTable } from "@/features/organization/components/OrganizationTable";
import { Tab } from "@/components/elements/Tab";
import { TopPage } from "@/modules/irohana-components/elements/TopPage";
import { background, divider } from "@/theme/colors";
import { EOrganizationContractStatus } from "@/types/enum";
import { findLabelByValue } from "@/utils/object";
import { Box, Stack } from "@mui/material";
import { FC, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const STATUS_TABS: EOrganizationContractStatus[] = [
  EOrganizationContractStatus.DURING_CONTRACT,
  EOrganizationContractStatus.CANCELED_CONTRACT,
  EOrganizationContractStatus.TRIAL,
  EOrganizationContractStatus.TRIAL_CANCELLED,
];

export const OrganizationListPage: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: statusOptions } = useEnum("EOrganizationContractStatus");
  const { data: countRes } = useOrganizationStatusCount();
  const counts = countRes?.data;

  const tabs = useMemo(() => {
    return STATUS_TABS.map((status) => ({
      label: `${findLabelByValue(statusOptions, status)} (${counts?.[status] ?? 0})`,
      value: status,
    }));
  }, [statusOptions, counts]);

  const statusParam = searchParams.get("status") as EOrganizationContractStatus | null;
  const activeStatus = statusParam && STATUS_TABS.includes(statusParam) ? statusParam : EOrganizationContractStatus.DURING_CONTRACT;

  const handleChange = (_event: React.SyntheticEvent, value: string | number) => {
    setSearchParams({ status: String(value) });
  };

  return (
    <Stack gap={2.5} sx={{ mt: 1, mb: 1 }}>
      <TopPage title="組織管理" enablePageBack={false} />
      <Stack
        sx={{
          border: `1px solid ${divider.middle}`,
          borderTop: "none",
          backgroundColor: background.white,
          borderRadius: "8px",
        }}
      >
        <Tab value={activeStatus} onChange={handleChange} options={tabs} />
        <Box padding="24px">
          <OrganizationTable contractStatus={activeStatus} />
        </Box>
      </Stack>
    </Stack>
  );
};
